import { useEffect } from "react";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, image, jsonLd, canonical }) {
  useEffect(() => {
    const full = title ? `${title} · SKGWEAR` : "SKGWEAR · CLOTHES FOR A BETTER YOU";
    document.title = full;
    const desc = description || "Premium streetwear από τη Θεσσαλονίκη. SKGWEAR — More than clothing.";
    const img = image || "https://images.unsplash.com/photo-1559697242-a465f2578a95?w=1200&q=80";
    const url = canonical || window.location.href.split("?")[0];

    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", full);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:image", img);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:site_name", "SKGWEAR");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", full);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", img);
    upsertLink("canonical", url);

    let script = document.getElementById("skg-jsonld");
    if (jsonLd) {
      if (!script) { script = document.createElement("script"); script.type = "application/ld+json"; script.id = "skg-jsonld"; document.head.appendChild(script); }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    return () => { const s = document.getElementById("skg-jsonld"); if (s) s.remove(); };
  }, [title, description, image, canonical, jsonLd]);

  return null;
}
